import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'container', 'backdrop', 'closeBtn', 'backBtn' ]

  connect() {
    this.toggleClass = '-left-full'
    this.element[this.identifier] = this
    this.isOpen = false
    this.ignoreDepthChange = false

    // Чтобы действие браузера "назад" закрывало сайдбар
    // и перемещало пользователя назад внутри сайдбара
    window.addEventListener('popstate', (event) => {
      // Если сайдбар закрыт, то прокручиваем историю,
      // пока не уйдём со страницы, чтобы лишние пустышки
      // не блокировали навигацию пользователя
      if (!this.isOpen && event.state && event.state.customNavigation === 'sidebar') {
        window.history.back()
      }

      // Если присутствует кнопка сайдбара назад,
      // прожимаем её и не триггерим повторно браузерное действие "назад"
      if (this.hasBackBtnTarget) {
        this.ignoreDepthChange = true
        this.backBtnTarget.click()
        return
      }

      // Если сайдбар открыт, и у него нет кнопки назад, закрываем
      this.close(null, false)
    })
  }

  open(e) {
    e.preventDefault()

    this.element.classList.add('open')
    this.isOpen = true
    this.containerTarget.classList.remove(this.toggleClass)
    this.backdropTarget.classList.remove('hidden')
    setTimeout(() => this.closeBtnTarget.classList.replace('absolute', 'fixed'), 200)
    this.positionCloseBtn()
    this._scrollLock()

    window.history.pushState({ customNavigation: 'sidebar' }, 'Sidebar Opened')
  }

  close(e, checkHistory = true) {
    if (e) { e.preventDefault() }

    this.element.classList.remove('open')
    this.isOpen = false
    this.containerTarget.classList.add(this.toggleClass)
    this.backdropTarget.classList.add('hidden')
    this.closeBtnTarget.classList.replace('fixed', 'absolute')
    this._scrollUnlock()

    if (checkHistory && Boolean(window.history.state?.customNavigation)) {
      window.history.back()
    }
  }

  closeWithEsc(e) {
    if (e.keyCode === 27 && !this.containerTarget.classList.contains(this.toggleClass)) {
      this.close(e);
    }
  }

  _scrollLock() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    this.scrollPosition = window.pageYOffset || document.body.scrollTop;
    document.body.classList.add('fixed', 'inset-x-0', 'overflow-hidden');
    document.body.style.top = `-${this.scrollPosition}px`;
  }

  _scrollUnlock() {
    document.body.style.paddingRight = null;
    document.body.classList.remove('fixed', 'inset-x-0', 'overflow-hidden');
    document.documentElement.scrollTop = this.scrollPosition;
    document.body.style.top = null;
  }

  positionCloseBtn() {
    if (window.innerWidth < 1024) {
      this.closeBtnTarget.style.top = `${this.containerTarget.getBoundingClientRect().top + 14}px`
      this.closeBtnTarget.style.left = `${this.containerTarget.getBoundingClientRect().width - 40}px`
    } else {
      this.closeBtnTarget.style.top = `${this.containerTarget.getBoundingClientRect().top + 20}px`
      this.closeBtnTarget.style.left = `${this.containerTarget.getBoundingClientRect().width - 52}px`
    }
  }

  incrementDepth() {
    window.history.pushState({ customNavigation: 'sidebar' }, 'Navigated inside sidebar')
  }

  decrementDepth() {
    // Если пользователь сам нажал кнопку назад,
    // то вслед за навигацией назад снимаем последнюю запись истории
    if (!this.ignoreDepthChange) {
      window.history.back()
      this.ignoreDepthChange = true
    }
  }
}
